import { Heading } from '@99designs/emu';
import { GridLayout, ProductCardGroup } from '@99designs/marketing-ui';
import type { RelatedProduct } from '../../types';

type Props = {
    products: RelatedProduct[];
};

export function RelatedProducts({ products }: Props) {
    return (
        <>
            <GridLayout>
                <Heading appearanceLevel={3} accessibilityLevel={2}>
                    {__('You might also like')}
                </Heading>
            </GridLayout>
            <ProductCardGroup products={products} />
        </>
    );
}
